export default __webpack_public_path__ + "static/primary-year-hero-image-3c3f9e97033237332babf90c27ef5ec0.jpg";